function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256,495.342c-50.996,0-99.68-15.833-140.787-45.788c-3.717-2.709-8.929-1.892-11.637,1.827  c-2.709,3.718-1.891,8.928,1.827,11.637c43.977,32.044,96.052,48.983,150.597,48.983c68.381,0,132.668-26.629,181.02-74.98  c48.351-48.352,74.98-112.64,74.98-181.019c0-51.375-15.163-100.935-43.851-143.32c-2.579-3.808-7.755-4.807-11.566-2.229  c-3.809,2.579-4.807,7.756-2.229,11.566c26.815,39.617,40.988,85.948,40.988,133.982c0,63.931-24.896,124.035-70.102,169.24  C380.036,470.446,319.932,495.342,256,495.342z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M90.44,428.833c-23.079-22.114-41.228-48.115-53.945-77.279c-13.162-30.189-19.836-62.337-19.836-95.554  c0-63.931,24.896-124.035,70.102-169.24C131.967,41.554,192.07,16.658,256,16.658c67.981,0,133,29.082,178.386,79.79  c3.068,3.427,8.331,3.72,11.762,0.651c3.427-3.068,3.719-8.333,0.651-11.76C398.256,31.105,328.713,0,256,0  C187.621,0,123.334,26.629,74.982,74.98C26.63,123.333,0.001,187.62,0.001,255.999c0,35.521,7.142,69.91,21.224,102.212  c13.602,31.195,33.013,59.002,57.691,82.65c1.614,1.547,3.688,2.314,5.761,2.314c2.191,0,4.379-0.86,6.015-2.566  C93.874,437.288,93.762,432.016,90.44,428.833z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M218.868,362.02c2.565,1.474,5.788,1.465,8.343-0.024l169.579-98.799c2.562-1.493,4.137-4.233,4.137-7.196  c0-2.963-1.575-5.705-4.137-7.196l-169.579-98.798c-2.576-1.501-5.76-1.51-8.343-0.024c-2.584,1.486-4.179,4.24-4.179,7.221v49.007  H125.2c-4.601,0-8.329,3.729-8.329,8.329v82.923c0,4.6,3.728,8.329,8.329,8.329h89.489v49.008  C214.69,357.78,216.284,360.534,218.868,362.02z M133.529,289.133v-66.265h89.489c4.601,0,8.329-3.729,8.329-8.329v-42.845  l144.706,84.307l-144.706,84.307v-42.845c0-4.6-3.728-8.329-8.329-8.329H133.529z"
});

var SvgNext = function SvgNext(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545"
    },
    d: "M256,503.671c136.785,0,247.671-110.886,247.671-247.672S392.786,8.329,256,8.329  S8.33,119.215,8.33,255.999S119.215,503.671,256,503.671z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "black"
    },
    points: "125.2,214.538 223.019,214.538 223.019,157.202 392.598,255.999 223.019,354.798   223.019,297.462 125.2,297.462 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M74.961,255.999c0-125.486,93.327-229.159,214.355-245.433  C278.418,9.101,267.3,8.329,256,8.329C119.215,8.329,8.33,119.215,8.33,255.999S119.215,503.67,256,503.67  c11.3,0,22.418-0.772,33.316-2.238C168.288,485.159,74.961,381.486,74.961,255.999z"
  }), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next.e86aa915.svg";
export { ForwardRef as ReactComponent };